/* global axios */
import ApiClient from './ApiClient';

class AdvancedWebhooksAPI extends ApiClient {
  constructor() {
    super('advanced_webhooks', { accountScoped: true });
  }

  preview(webhookParams) {
    return axios.post(`${this.url}/preview`, {
      webhook: webhookParams,
    });
  }
}

export default new AdvancedWebhooksAPI();
